var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('TopMenu',{attrs:{"propsmenu":_vm.menu}}),_c('NavMenu',{attrs:{"propsmenu":_vm.menu}}),_c('NavSetting'),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }